import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { Breadcrumb as RawBreadcrumb } from '@alicloud/console-components';
/**
 * 定义面包屑。通常包括若干个{@link IBreadcrumb.Item | Breadcrumb.Item}作为子元素。
 * @public
 */

var Breadcrumb = function Breadcrumb(props) {
  return React.createElement(RawBreadcrumb, _extends({
    maxNode: 5,
    separator: "/"
  }, props));
};

Breadcrumb.Item = RawBreadcrumb.Item;
export default Breadcrumb;